
import { Options, Vue } from 'vue-class-component'
import TextParticle from '@/components/TravelText.vue'
import PicParticles from '@/utils/PicParticles'
import { CountUp } from 'countup.js'
import { Odometer } from 'odometer_countup';
import * as echarts from 'echarts';

let zhangwei, envBg;
@Options({
  name: 'Environment',
  components: {
    TextParticle,
  },
  props: {},
  data() {
    return {
      isShow: false,
      xsYear: 2017,
      xsCount: 50,
      isShowDufu: 0,
      isShowJxs: false,
      isShowPm25: false,
      isShowPmText: false,
      isShowAq: false,
    }
  },
  computed: {},
  mounted() {
    this.isShow = true;
    this.$nextTick(() => {
      this.init();
      this.envBg();
    });
    // this.pmChart();
  },
  beforeDestroy() {
    zhangwei?.forceDestroy();
    envBg?.forceDestroy();
  },
  methods: {
    init() {
      const _this = this;
      const vw = window.innerWidth;
      const vh = window.innerHeight;

      let isShowDufu = false;
      let isShowJxs = false;
      let isShowAq = false;
      let isShowPm25 = false;
      let isShowPmText = false;
      let isShowPmCount = false;
      let isShowZhangwei = false;
      let isShowPmChart = false;
      window.addEventListener('scroll', () => {
        if (!isShowDufu) {
          const dufuTop = document.querySelector('#env-dufu')?.getBoundingClientRect().top;
          /* if (dufuTop && dufuTop > 0 && !zhangwei) {
            _this.zwParticles();
          } */
          if (dufuTop && dufuTop < vh / 1.2) {
            _this.isShowDufu = 1;
          }

          if (dufuTop && dufuTop < vh / 2) {
            _this.isShowDufu = 2;
            isShowDufu = true;
          }
        }

        if (!isShowZhangwei) {
          const top = document.querySelector('#zhangwei')?.getBoundingClientRect().top;
          if (top && top < vh / 1.1) {
            _this.zwParticles();
            isShowZhangwei = true;
          }
        }

        if (!isShowJxs && isShowDufu) {
          const top = document.querySelector('#jianxue')?.getBoundingClientRect().top;
          if (top && top < vh) {
            _this.isShowJxs = true;
            isShowDufu = false;
          }

          if (top && top < (vh / 2)) {
            isShowJxs = true;
            _this.$nextTick(() => {
              _this.xueshan();
            });

            /* _this.isShowDufu = 0;
            if (zhangwei) {
              zhangwei.forceDestroy();
              zhangwei = null;
            } */
          }
        }

        if (!isShowAq) {
          const top = document.querySelector('#aq-content')?.getBoundingClientRect().top;
          if (top && top < vh / 2) {
            _this.isShowAq = true;
          }

          if (top && top < (vh / 4)) {
            isShowAq = true;
            _this.$nextTick(() => {
              _this.aqCount();
            });
          }
        }

        if (!isShowPm25 && isShowAq) {
          const top = document.querySelector('#pm-particle')?.getBoundingClientRect().top;
          if (top && top < vh / 2) {
            isShowPm25 = true;
            _this.isShowPm25 = true;
          }
        }

        if (!isShowPmChart) {
          const top = document.querySelector('#pm-chart-box')?.getBoundingClientRect().top;
          if (top && top < vh / 2) {
            isShowPmChart = true;
            _this.pmChart();
          }
        }

        if (!isShowPmText && isShowPm25) {
          const top = document.querySelector('#pm-text')?.getBoundingClientRect().top;
          if (top && top < vh / 2) {
            isShowPmText = true;
            _this.isShowPmText = true;
          }
        }

        if (!isShowPmCount && isShowPmText) {
          const top = document.querySelector('.pm25')?.getBoundingClientRect().top;
          if (top && top < vh / 2) {
            _this.pmCount();
            isShowPmCount = true;
          }
        }
      }, false)
    },
    pmChart() {
      const chartDom = document.getElementById('pm-chart');
      const myChart = echarts.init(chartDom);

      myChart.setOption({
        grid: {
            left: 0,    // 左边的距离
            right: 0,   // 右边的距离
            top: 0,     // 顶部的距离
            bottom: 0,   // 底部的距离
        },
        textStyle: {
            fontFamily: 'jdzh',
            fontSize: 16
        },
        xAxis: {
            type: 'value',
            show: false
        },
        yAxis: {
            type: 'category',
            data: ['2023', '2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015', '2014', '2013'],
            axisLabel: {
                inside: true,
                color: '#11a8df',
                fontSize: 16
            },
            axisLine: {
                show: false
            },
        },
        // 系列列表
        series: [
            {
                name: 'echarts-3',
                type: 'bar',
                barWidth: '80%', // 设置柱子宽度为30
                itemStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 1,
                        y2: 0,
                        colorStops: [
                            {
                                offset: 0, color: 'rgba(17, 168, 223, 0)'
                            },
                            {
                                offset: 1, color: '#13b7f3'
                            }
                        ],
                        global: false
                    }
                },
                label: {
                    show: true,
                    position: 'insideRight',
                    color: '#ffffff'
                },
                data: [285, 282, 299, 280, 287, 251, 235, 214, 214, 223, 132]
            }
        ]
      });
    },
    zwParticles() {
      zhangwei = new PicParticles({
        container: document.querySelector('#zhangwei'),
        imgUrl: require('../../assets/img/environment/e_people.png'),
        pix: 10,
        duration: 2000
      })
    },
    xueshan() {
      const _this = this;
      const year = [
        [2017, 50],
        [2018, 56],
        [2019, 65],
        [2020, 70],
        [2021, 63],
        [2022, 52],
        [2023, 66],
      ];
      let showXsIntr;

      loop();
      function loop() {
        let index = 0;
        clearInterval(showXsIntr);
        showXsIntr = setInterval(() => {
          _this.xsYear = year[index][0];
          _this.xsCount = year[index][1];
          index++;
          if (index >= year.length) {
            clearInterval(showXsIntr);
          }
        }, 300);
      }
    },
    // 空气质量
    aqCount() {
      const duration = 3;
      new CountUp('aq-year', 2023, {
        // plugin: new Odometer({ duration: 2, lastDigitDelay: 0 }),
        useGrouping: false,
        startVal: 2013,
        duration: 2,
        useEasing: false,
      }).start();

      new CountUp('aq-count', 285, {
        useGrouping: false,
        startVal: 132,
        duration,
        useEasing: false,
      }).start();
    },
    pmCount() {
      const duration = 3;
      new CountUp('pm-year', 2023, {
        // plugin: new Odometer({ duration: 2, lastDigitDelay: 0 }),
        useGrouping: false,
        startVal: 2013,
        duration: 2,
        useEasing: false,
      }).start();

      new CountUp('pm-count', 30, {
        useGrouping: false,
        startVal: 72,
        duration,
        useEasing: false,
      }).start();
    },
    envBg() {
      envBg = new PicParticles({
        container: document.querySelector('#env-bg'),
        imgUrl: require('../../assets/img/environment/env_bg.png'),
        pix: 30,
        radius: 60,
        duration: 3000
      })
    }
  }
})
export default class Environment extends Vue {

}
